import {
  getPaymentByRangeOfDates,
  updatePayment
} from "@/collections/payments";
import moment from "moment";
import { getOrdersByRangeOfDates } from "@/collections/orders";

const PAYMENT_METHOD_CASH = "cash";
const PAYMENT_METHOD_DATOFONO = "datafono";
const PAYMENT_METHOD_GOOGLE_PAY = "googlepay";
const PAYMENT_METHOD_APPLE_PAY = "applepay";
const PAYMENT_METHOD_BIZUM = "bizum";
export default {
  data() {
    return {};
  },
  methods: {
    async buildOrderSummary(opened_on, closed_on) {
      try {
        let orders = await getOrdersByRangeOfDates(opened_on, closed_on);
        console.log("orders", orders);
        return {
          opening_time: orders.length
            ? moment(orders[0]?.time?.seconds * 1000).toDate()
            : opened_on,
          orders: this.getOrdersSummary(orders),
          products: this.getProductSummary(orders),
          customers: this.getCustomerSummary(orders)
        };
      } catch (error) {
        let message = "Algo salió mal";
        this.setlogError(
          "build_order_summary",
          message,
          error.stack,
          this.$options.name
        );
        console.log("Error getting documents: ", error);
      }
    },
    // Return totalAmount within opening and closing time
    async buildPaymentSummary(opened_on, closed_on, zClosureId) {
      try {
        let payments = await getPaymentByRangeOfDates(opened_on, closed_on);
        let obj = {
          total_change_count_accumulated: 0,
          total_invoiced_in_apple_pay: 0,
          total_invoiced_in_google_pay: 0,
          total_invoiced_in_bizum: 0,
          total_invoiced_in_datafono: 0,
          total_invoiced_on_credit_card: 0,
          total_invoiced_in_cash: 0,
          cntCash: 0,
          cntCreditCard: 0,
          cntApplePay: 0,
          cntGpay: 0,
          cntDatafono: 0,
          cntBizum: 0,
          totalAmount: 0,
          closing_time: payments.length
            ? moment(
                payments[payments.length - 1]?.payment_on?.seconds * 1000
              ).toDate()
            : closed_on
        };
        obj.totalAmount = payments.reduce(
          (acc, n) => acc + parseFloat(n.amount_paid_by_user || 0),
          0
        );

        for (let payment of payments) {
          let paymentMethod = payment.payment_method;
          let now = moment().format();
          if (paymentMethod === PAYMENT_METHOD_CASH) {
            obj.total_invoiced_in_cash += parseFloat(
              payment.amount_paid_by_user
            );
            obj.total_change_count_accumulated += parseFloat(
              payment.cash_payment.change
            );
            obj.cntCash += 1;
          } else if (paymentMethod === PAYMENT_METHOD_DATOFONO) {
            obj.total_invoiced_in_datafono += parseFloat(
              payment.amount_paid_by_user
            );
            obj.cntDatafono += 1;
          } else if (paymentMethod === PAYMENT_METHOD_GOOGLE_PAY) {
            obj.total_invoiced_in_google_pay += parseFloat(
              payment.amount_paid_by_user
            );
            obj.cntGpay += 1;
          } else if (paymentMethod === PAYMENT_METHOD_APPLE_PAY) {
            obj.total_invoiced_in_apple_pay += parseFloat(
              payment.amount_paid_by_user
            );
            obj.cntApplePay += 1;
          } else if (paymentMethod === PAYMENT_METHOD_BIZUM) {
            obj.total_invoiced_in_bizum += parseFloat(
              payment.amount_paid_by_user
            );
            obj.cntBizum += 1;
          } else {
            obj.total_invoiced_on_credit_card += parseFloat(
              payment.amount_paid_by_user
            );
            obj.cntCreditCard += 1;
          }
          // Comment below line if you don't wish to update payment collection
          let payment_obj = {
            z_closure_id: zClosureId,
            updated_on: now,
            id: payment.id
          };
          await updatePayment(payment.id, payment_obj);
        }
        return obj;
      } catch (error) {
        let message = "Algo salió mal";
        this.setlogError(
          "build_payment_summary",
          message,
          error.stack,
          this.$options.name
        );
        console.log("Error getting documents: ", error);
      }
    },
    getOrdersSummary(orders) {
      let foodCount = 0;
      let drinkCount = 0;
      let dessertCount = 0;
      let totalOrdersAmount = orders.reduce(
        (acc, n) =>
          acc + parseFloat(n.price || 0) * parseFloat(n.quantity || 0),
        0
      );
      let foodAmount = orders
        .filter(x => this.isFoodType(x.product_type_id))
        .reduce(
          (acc, n) =>
            acc + parseFloat(n.price || 0) * parseFloat(n.quantity || 0),
          0
        );
      let drinkAmount = orders
        .filter(x => this.isDrinkType(x.product_type_id))
        .reduce(
          (acc, n) =>
            acc + parseFloat(n.price || 0) * parseFloat(n.quantity || 0),
          0
        );
      let dessertAmount = orders
        .filter(x => this.isDessertType(x.product_type_id))
        .reduce(
          (acc, n) =>
            acc + parseFloat(n.price || 0) * parseFloat(n.quantity || 0),
          0
        );
      orders.forEach(x => {
        if (this.getProductType(x.product_type_id) === "drinks") {
          drinkCount++;
        } else if (this.getProductType(x.product_type_id) === "food") {
          foodCount++;
        } else {
          dessertCount++;
        }
      });

      return {
        totalOrders: orders.length,
        foodCount: foodCount,
        drinkCount: drinkCount,
        dessertCount: dessertCount,
        foodAmount: foodAmount,
        drinkAmount: drinkAmount,
        dessertAmount: dessertAmount,
        totalOrdersAmount: totalOrdersAmount
      };
    },
    getCustomerSummary(orders) {
      let customers = [];
      for (let item of orders) {
        const newCustomer = {
          email: item.email,
          orders: 1,
          amount: parseFloat(item.price) * item.quantity
        };
        customers.push(newCustomer);
      }
      return customers;
    },
    getProductSummary(orders) {
      let products = [];
      for (let item of orders) {
        // get count from orders
        let productAdded = products.find(p => p.product_id === item.product_id);
        if (productAdded) {
          productAdded.count += 1;
        } else {
          const newProduct = {
            product_id: item.product_id,
            count: 1,
            type: this.getProductType(item.product_type_id),
            product_name: item.name,
            price: item.price
          };
          products.push(newProduct);
        }
      }
      return products;
    },
    getProductType(type_id) {
      if (type_id === this.$store.state.productTypeIds.drinks) {
        return "drinks";
      }

      if (type_id === this.$store.state.productTypeIds.food) {
        return "food";
      }

      return "dessert";
    },
    isFoodType(productTypeSelected) {
      return productTypeSelected === this.$store.state.productTypeIds.food;
    },
    isDrinkType(productTypeSelected) {
      return productTypeSelected === this.$store.state.productTypeIds.drinks;
    },
    isDessertType(productTypeSelected) {
      return productTypeSelected === this.$store.state.productTypeIds.dessert;
    }
  }
};
